import { Translation } from '@ps/web-shared-components';
import { addDays, addYears } from 'date-fns';
import React from 'react';

import InfoMessage from '@swf/components/InfoMessage/InfoMessage';
import { StatusCode } from '@swf/core/enums/statusCode';

import AccountDate from '../../AccountDate/AccountDate';
import { ExclusionType } from '../../definitions';

import {
  TXTWCL_This_means_that_your_account_h_ELL,
  TXTWCL_This_means_you_wonXt_be_able_t_ELL_5,
  TXTWCL_WeXll_automatically_reopen_you_ELL,
  TXTWCL_WeXll_automatically_reopen_you_ELL_1,
  TXTWCL_We_canXt_process_your_request__ELL_1,
  TXTWCL_YouXre_permanently_self_exclud_ELL,
  TXTWCL_YouXre_taking_a_break,
  TXTWCL_YouXre_temporarily_self_exclud_ELL,
  TXTWCL_You_will_be_able_to_create_a_n_ELL_1
} from './ExclusionResponseDK.messages.json';

interface Props {
  error?: boolean;
  statusCode?: StatusCode;
  exclusionType?:
    | ExclusionType.Break
    | ExclusionType.SelfExclusion
    | ExclusionType.PermanentSelfExclusion;
  timeUntil?: number | string;
  daysRequested?: number;
}

const ExclusionResponseDK: React.FC<Props> = ({
  error,
  statusCode,
  exclusionType,
  timeUntil,
  daysRequested
}) => {
  const selfExclusionSuccessful = statusCode === StatusCode.USER_SELF_EXCLUDED;

  const getEndDate = () => {
    const currentDate = new Date();
    if (timeUntil) {
      return new Date(timeUntil);
    } else if (daysRequested === 0) {
      return addYears(currentDate, 1);
    } else {
      return addDays(currentDate, daysRequested || 0);
    }
  };

  const endDate = getEndDate();

  const formattedEndDate = (
    <b>
      <AccountDate date={endDate} />
    </b>
  );

  switch (true) {
    case error:
      return (
        <InfoMessage type="error">
          <Translation {...TXTWCL_We_canXt_process_your_request__ELL_1} />
        </InfoMessage>
      );

    case selfExclusionSuccessful && exclusionType === ExclusionType.Break:
    case selfExclusionSuccessful && exclusionType === ExclusionType.SelfExclusion:
      return (
        <InfoMessage
          type="confirmation"
          messageTitle={
            exclusionType === ExclusionType.Break
              ? TXTWCL_YouXre_taking_a_break
              : TXTWCL_YouXre_temporarily_self_exclud_ELL
          }
        >
          <Translation
            {...TXTWCL_WeXll_automatically_reopen_you_ELL_1}
            values={{ 0: formattedEndDate }}
          />
        </InfoMessage>
      );

    case selfExclusionSuccessful && exclusionType === ExclusionType.PermanentSelfExclusion:
      return (
        <InfoMessage type="confirmation" messageTitle={TXTWCL_YouXre_permanently_self_exclud_ELL}>
          <Translation {...TXTWCL_This_means_that_your_account_h_ELL} />{' '}
          <Translation
            {...TXTWCL_You_will_be_able_to_create_a_n_ELL_1}
            values={{ 0: formattedEndDate }}
          />
        </InfoMessage>
      );

    default:
      return (
        <>
          <Translation
            tagName="p"
            {...TXTWCL_This_means_you_wonXt_be_able_t_ELL_5}
            values={{ 0: formattedEndDate }}
          />
          <Translation tagName="p" {...TXTWCL_WeXll_automatically_reopen_you_ELL} />
        </>
      );
  }
};

export default ExclusionResponseDK;
